export const currentTimeFormat = "HH:mm"